import C from "@/components/Spinner.module.css";
import { cn } from "@/utils/classNames.ts";

export function Spinner({ headless }: { headless?: boolean }) {
    return (
        <div className={cn(C.Spinner, headless && C.headless)}>
            <div className={C.Content} />
        </div>
    );
}
